import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { BasicLoader } from '../../loaders/basic-loader';
import { PopupStore } from '../popup.store';

export const FixErrorProcessing = observer<{ popupStore: PopupStore }>(({ popupStore }) => {
  const { t } = useTranslation();
  const localStore = useLocalObservable(() => ({
    displayAltText: false,
    changeDisplayAltText(_value: boolean) {
      this.displayAltText = _value;
    },
  }));
  useEffect(() => {
    setTimeout(() => localStore.changeDisplayAltText(true), 5000);
  }, [localStore]);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <BasicLoader isLoading={true}>
        <></>
      </BasicLoader>
      {/* NOTE: This has been commented out because it is not used anywhere in the codebase and there are no translations for it */}
      {/* <h3 className="cust-my-2">{localStore.displayAltText ? t('fixError.popup.altText') : t('fixError.popup.onIt')}</h3>
      <div className="text-regular text-center">
        {localStore.displayAltText ? t('fixError.popup.onItDesc') : t('fixError.popup.altDesc')}
      </div> */}
    </div>
  );
});